<template>
	<div>
		<a-spin :spinning="loading">
			
			<a-alert v-if="agent.is_agent == 1" message="温馨提示" type="info">
			      <p slot="description">
			          尊敬的客户您好，您已获得独立部署的代理权限。当前账户余额：<span class="cl-red">¥{{agent.money}}</span>,您的代理识别码:{{agent.code}}
			      </p>
			</a-alert>
			<a-alert v-else message="温馨提示" type="error">
			      <p slot="description">
			          尊敬的客户您好，您当前未获得独立部署的代理权限。
			      </p>
			</a-alert>
			
			<div class="form-search-box  mt16">
				<a-form layout="inline">
					<a-form-item label="域名筛选">
						<a-input v-model="url" placeholder="请输入域名名称"></a-input>
					</a-form-item>
				</a-form>
			</div>
			<div class="bg-w">
				
				
				<div class="wxb-table-gray">
					<a-table rowKey="site_id" :columns="cols"  :data-source="getDatas"
					 >
						<template slot="is_empower" slot-scope="is_empower,record">
							<a-tag v-if="is_empower == 0" color="red">
								未授权
							</a-tag>
							<a-tag v-else color="green">
							        已授权
							</a-tag>
						</template>
						
						
						<template slot="action" slot-scope="text,record">
							 <a-dropdown>
							        <a-button>操作</a-button>
							        <a-menu slot="overlay">
							          <a-menu-item  v-if="text.is_empower == 0">
							           <a @click="empowerCheck(text.site_id)" href="javascript:void(0);">开通授权</a>
							          </a-menu-item>
							          <a-menu-item v-if="text.is_empower == 1">
							             <a @click="renewCheck(text.site_id)" href="javascript:void(0);">升级续费</a>
							          </a-menu-item>
							          <a-menu-item v-if="text.is_empower == 1">
							            <a @click="changeIpAct(text.site_id)" href="javascript:void(0);">更换IP</a>
							          </a-menu-item>
									  <a-menu-item v-if="text.is_empower == 1">
											<router-link :to="'/application/agent/site?id='+text.site_id">应用插件</router-link>
									  </a-menu-item>
							        </a-menu>
							      </a-dropdown>
						</template>
					</a-table>
				</div>
			</div>
			
			
			
		</a-spin>
		
		<a-modal
		      title="更换Ip"
		      :visible="visible"
		      :confirm-loading="confirmLoading"
		      @ok="handleOk"
		      @cancel="handleCancel"
		    >
		     <a-input v-model="ip" placeholder="请输入新IP地址"></a-input>
		    </a-modal>
	</div>
</template>

<script>
	export default{
		
		data(){
			return {
				loading:false,
				visible:false,
				confirmLoading:false,
				url:'',
				agent:{
					is_agent:0,
					money:0,
					code:'',
				},
				ip:'',
				siteId:0,
				datas:[],
				cols: [
					{title: '站点ID',dataIndex: 'site_id',align: 'center',ellipsis: true},
					{title: '域名',dataIndex: 'host',align: 'center'},
					{title: '站点名称',dataIndex: 'site_name',align: 'center'},
					{title: 'ip',dataIndex: 'ip',align: 'center',ellipsis: true},
					{title: '联系方式',dataIndex: 'mobile',align: 'center',ellipsis: true},
					{title: '是否授权',dataIndex: 'is_empower',align: 'center',scopedSlots: {customRender: 'is_empower'}},
					{title: '升级到期',dataIndex: 'upgrade_expire_time',align: 'center'},
					{title: '操作',key: 'action',align: 'center',scopedSlots: {customRender: 'action'}},
				],
			}
		},
		created(){
			this.getAgentInfo();
			this.getSiteList();
		},
		computed:{
			getDatas(){
				if(this.url == '') return  this.datas;
				let arr = new Array;
				
				for(var a in this.datas){
					if(this.datas[a].host.indexOf(this.url) > -1){
						arr.push(this.datas[a]);
					}
				}
				
				return arr;
			}
		},
		methods:{
			changeIpAct(id){
				this.siteId = id;
				this.visible = true;
			},
			handleOk(){
				this.confirmLoading = true;
				this.$http.api('platform/admin/changeIp',{
					siteId:this.siteId,
					ip:this.ip,
				}).then(res=>{
					this.confirmLoading= false;
					this.visible = false;
					this.$message.success('操作成功');
					this.getSiteList();
				}).catch(res=>{
					this.confirmLoading = false;
				});
			},
			handleCancel(){
				this.visible = false;
			},
			empowerCheck(id){
				this.$http.api('platform/admin/getEmpower').then(res=>{
					console.log(res)
					this.empowerAct(id,res.money)
				})
			},
			empowerAct(id,money){
				this.$confirm({
					title:'您确定为站点'+id+'开通授权么?花费'+money+'代理金确定开通将直接扣费',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('platform/admin/empower',{
								siteId:id,
							}).then(res=>{
								this.$message.success('开通成功');
								this.getAgentInfo();
								this.getSiteList();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				});
			},
			renewCheck(id){
				this.$http.api('platform/admin/getRenew').then(res=>{
					this.renewAct(id,res.money)
				})
			},
			renewAct(id,money){
				this.$confirm({
					title:'您确定为站点'+id+'续费么?花费'+money+'代理金确定续费将直接扣费',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('platform/admin/renew',{
								siteId:id,
							}).then(res=>{
								this.$message.success('续费成功');
								this.getAgentInfo();
								this.getSiteList();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				});
			},
			getAgentInfo(){
				
				this.loading = true;
				this.$http.api('platform/admin/getAgentInfo').then(res=>{
					this.loading = false;
					this.agent = res.agent;
				}).catch(res=>{
					this.loading = false;
				});
				
			},
			getSiteList(){
				this.$http.api('platform/admin/getSiteList').then(res=>{
					this.datas = res.datas;
				}).catch(res=>{
					
				});
			}
			
		}
	}
</script>

<style>
	
</style>